import { useMemo } from 'react';
import type { FC } from 'react';
import { useRouter } from '@application/utils';
import { BREAKPOINTS } from '@presentation/styles';
import { useMediaQuery } from 'react-responsive';
import * as Styled from './styled';
import type { CookiesBannerProps } from './types';

export * from './types';

export const CookiesBanner: FC<CookiesBannerProps> = (props) => {
  const { onCustomizeClick, onAcceptClick } = props;
  const { translate } = useRouter();
  const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.phone}px)` });
  const longCookiesText = translate('common.banners.cookie.text.long');
  const shortCookiesText = translate('common.banners.cookie.text.short');

  const mobileText = useMemo(() => {
    if (!isMobile) {
      return longCookiesText;
    }
    return shortCookiesText;
  }, [isMobile, longCookiesText, shortCookiesText]);

  return (
    <Styled.Wrapper>
      <Styled.Text>{mobileText}</Styled.Text>
      <Styled.Container>
        <Styled.OkButton onClick={onAcceptClick}>
          {translate('common.buttons.iUnderstand')}
        </Styled.OkButton>

        <Styled.CustomizeButton onClick={onCustomizeClick}>
          {translate('common.buttons.customize')}
        </Styled.CustomizeButton>
      </Styled.Container>
    </Styled.Wrapper>
  );
};
